import axios from 'axios'
import store from '../store';

export default class CoinPaymentsService {


    async createTransaction(orderid, email, username, packagename) {

        const res = await axios({
            method: 'post',
            headers: {
                authorization: store.state.currentUser.token
            },
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/coinpayments/createtransaction',
            data: {
                item_number: orderid,
                item_name: packagename, 
                buyer_name: username, 
                email: email,
                currency1: 'BTC',
                currency2: 'BTC'
            }
        });

        return res.data;
    }

    async getTransaction(orderid) {

        const res = await axios({
            method: 'get',
            headers: {
                authorization: store.state.currentUser.token
            },
            url: process.env.VUE_APP_AUTH_URL + 'api/v1/coinpayments/gettransaction/',
            params: {
                purchase_id: orderid
            }
        });

        return res.data;
    }


}